export const reviewsData = [
  {
    title: "I use it daily",
    text: "Awesome app to keep on top of my German practice. I use it everyday. It’s simple and easy to use",
    username: "pwr8",
    date: "Jan 5, 2026",
    rating: 5,
    country: "United States",
  },
  {
    title: "Amazing app!",
    text: "Really love this app!! It has help me improved my German language within a few weeks. Danke!!!",
    username: "Anniemoon96",
    date: "Jan 5, 2026",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Excellent Tool for Learning German Vocabulary",
    text: "Great German flashcard app! Easy to use, well organized, and perfect for quick daily practice. The spaced repetition helps vocabulary stick, and the examples make learning clear and effective. Highly recommended for German learners!",
    username: "Bene.pkt",
    date: "Jan 3, 2026",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Super Useful!!!",
    text: "Love the concept , it does help to learn and translate. thanks 🙏🏻",
    username: "Naman Vaishanv",
    date: "Jan 2, 2026",
    rating: 5,
    country: "India",
  },
  {
    title: "Really works!",
    text: "This really helped me learn the language. Really great app!",
    username: "Kever5657",
    date: "Dec 28, 2025",
    rating: 5,
    country: "Ireland",
  },
  {
    title: "great app for learning German vocabulary",
    text: "user-friendly designs and very easy-to-use",
    username: "iperkk",
    date: "Dec 25, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Simple and effective",
    text: "I’ve been using this app for couple of days to learn German and I really like it. It’s clean, easy to use, and I’ve already learned a few new words. Great app for beginners.",
    username: "arahmancsd",
    date: "Dec 24, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Extremely helpful!",
    text: "This app does exactly what it says it’s going to do and does it well! If you are trying to learn German this app helps you learn in a very efficient way.",
    username: "GregorieSz",
    date: "Dec 24, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "güzel",
    text: "çok beğendim",
    username: "furkancingozz16",
    date: "Dec 22, 2025",
    rating: 5,
    country: "Türkiye",
    version: "1.3.1",
  },
  {
    title: "La migliore app per imparare il tedesco",
    text: "Un compagno di classe mi ha consigliato questa app perché è davvero molto efficace per apprendere il vocabolario e la grammatica tedeschi.",
    username: "BrosprosJ",
    date: "Dec 21, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Great app",
    text: "I wanted to learn german and this was the perfect app for that!",
    username: "Connoryyyy",
    date: "Dec 21, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Learning Something New",
    text: "This really helps me learn a new language and makes learning something new",
    username: "rohankewal",
    date: "Dec 19, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Harika",
    text: "Almanca öğrenmek isteyenler için kullanımı çok kolay ve rahat tavsiye ederim",
    username: "Sincap77",
    date: "Dec 18, 2025",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Great app for a beginner",
    text: "To surprise my German boyfriend, i found this app. It has a very comprehensive collection of German grammar and vocabulary, including a dictionary and lessons, covering all the needs of a beginner. Now i can study German anytime.",
    username: "Davvvvvvid00",
    date: "Dec 16, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Merveilleux!",
    text: "J’utilise l’application depuis quelques mois et elle est très pratique. Simple et sans artifice, elle présente les éléments essentiels pour permettre un apprentissage efficace de la langue. Merci beaucoup pour cette application!",
    username: "Michka2811",
    date: "Dec 15, 2025",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Ottima per il ripasso",
    text: "App ben fatta. Contiene flashcard semplici utili per migliorare e studiare il tedesco. Imparo nuovi vocaboli ogni giorno, consigliata!",
    username: "Ampe96",
    date: "Dec 13, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Loved it!",
    text: "This app is really helpful for learning german. I have been using this for a while and completed most of the lessons. It’s fun and interactive and easy to understand german. Recommending it.",
    username: "sofia980",
    date: "Dec 13, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Utile e facile!",
    text: "Ho trovato questa app molto utile per ripassare prima dell’esame, la consiglio!",
    username: "Gabri mi",
    date: "Dec 13, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Amazing for learning German",
    text: "A great alternative to Duolingo for learning German, as this app provides a much stronger focus on teaching grammar. I hope they will soon add Spanish.",
    username: "LucasSwing",
    date: "Dec 11, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app",
    text: "Linguico is a remarkably effective, no-nonsense German learning app",
    username: "Snowkz",
    date: "Dec 11, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "A great resource!",
    text: "I wish I had found this app before my trip to Germany and Switzerland! It really is very helpful in learning German and I can see myself making progress each time I use the app.",
    username: "Tom87870",
    date: "Dec 8, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Рахмет!",
    text: "Неміс тілін үйреніп жүрсем, осы қосымша шынымен көмектесті. Сөздерді тез жаттатқызады, «der-die-das» үйренуге өте ыңғайлы. Қарапайым, түсінікті, кез келген уақытта ашып кете бересің. Ұнайды, қолдануға ыңғайлы.",
    username: "Shaq637",
    date: "Dec 7, 2025",
    rating: 5,
    country: "Kazakhstan",
  },
  {
    title: "Odlicna aplikacija za ucenje njemackog",
    text: "Najvise mi se svidja sto ima ogroman broj rijeci, koje su korisne i potrebne za svakodnevnu komunikaciju. Sve pohvale",
    username: "Luxylone",
    date: "Dec 7, 2025",
    rating: 5,
    country: "Serbia",
  },
  {
    title: "Really Helpful for Learning German!",
    text: "I have been using this app to learn german and it’s been super helpful. The lessons are simple, the grammar tips make sense. Overall it’s a really friendly easy to use app that actually helps to understand German step by steps. Loved it!",
    username: "octamaggot",
    date: "Dec 6, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Is time to learn german",
    text: "U can catch up easily",
    username: "kclaw92",
    date: "Dec 5, 2025",
    rating: 5,
    country: "Singapore",
  },
  {
    title: "Good der die das app",
    text: "I mainly use this app for learning 'der die das' articles.",
    username: "Gemini_mc",
    date: "Dec 4, 2025",
    rating: 5,
    country: "Hong Kong",
  },
  {
    title: "Very good for learning German",
    text: "Highly detailed, built-in Anki flashcards for learning German vocabulary. The cards include grammar notes, including irregular verb conjunctions, just like you’d find in a school textbook. This app is free and personally I find it far more effective than Duolingo for learning German.",
    username: "InvisibleG",
    date: "Dec 1, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Very helpful app",
    text: "Great format for learning German. Brushing up on my language skills for business trip next month",
    username: "Donkey259",
    date: "Dec 1, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Great for learning",
    text: "Been using this app for 2 days and my German has improved. I love the der, die das flashcards!",
    username: "JonathanRoye",
    date: "Nov 29, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app",
    text: "Great app to learn German and get a more solid foundation",
    username: "Simon.trut",
    date: "Nov 13, 2025",
    rating: 5,
    country: "Spain",
  },
  {
    title: "Aplicatie practica",
    text: "Foarte usor de urmarit gramatica cu lectiile si testele predefinite.",
    username: "George5765",
    date: "Nov 8, 2025",
    rating: 5,
    country: "Romania",
  },
  {
    title: "Very knowledgeable",
    text: "Great app! It’s packed with knowledge and teaches concepts really well. Learning feels easy and enjoyable.",
    username: "Tech-truth",
    date: "Nov 7, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Nice app",
    text: "Helped me lot to learn German.",
    username: "TusharChandak",
    date: "Nov 6, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "Keep going — this app has real potential!",
    text: "I really enjoy using this app to learn German. Please, keep developing it — you're onto something great here:) I sent you some suggestions via email",
    username: "Lex357.2",
    date: "Oct 19, 2025",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "Super!",
    text: "Einfach, aber genial.",
    username: "faszilaji88",
    date: "Oct 8, 2025",
    rating: 5,
    country: "Austria",
  },
  {
    title: "Excellent German Flashcards",
    text: "Excellent app for learning German vocabulary with Anki flashcards. The decks are practical because they are sorted by word frequency in German.",
    username: "irvy94",
    date: "Sep 23, 2025",
    rating: 5,
    country: "Ireland",
  },
  {
    title: "Amazing app!",
    text: "Loved the idea and the execution. Makes German learning very easy!",
    username: "hminahsu",
    date: "Sep 23, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "Excellent app for learning German words!",
    text: "I use this app during my commute to learn German vocabulary and practice grammar through exercises. It is great",
    username: "Aniruddha Lanke",
    date: "Sep 18, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "I love this app!",
    text: "Simple and useful!",
    username: "Novak wl",
    date: "Sep 17, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Best German Learning App",
    text: "Really enjoying the different exercise types keeping me motivated. I improved my German a lot with this app!",
    username: "nobody889988",
    date: "Sep 16, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "this is app i need",
    text: "i need learn German, this app is very useful. Hightly recomend.",
    username: "john_kame_89",
    date: "Sep 15, 2025",
    rating: 5,
    country: "Singapore",
  },

  {
    title: "好用",
    text: "這是一個非常好的德語學習應用程式。我常常用它來練習德語冠詞「der, die, das」以及擴充德語詞彙。它完全免費，而且使用起來很有趣！",
    username: "Fawkeswei",
    date: "Sep 15, 2025",
    rating: 5,
    country: "Taiwan",
  },
  {
    title: "تطبيق شامل لتعلم الالماني",
    text: "توجد تمارين كثيرة جدا ومفيدة وقاموس ترجمة من الانجليزي الى الالماني والعكس",
    username: "iHU5",
    date: "Sep 14, 2025",
    rating: 5,
    country: "Saudi Arabia",
  },
  {
    title: "Amazing App",
    text: "This app is so amazing! It is super useful for all my studying!",
    username: "Beavis~",
    date: "Sep 11, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Almanca için harika",
    text: "Anlamsız ayrıntılardan uzak, hedefe odaklı, kullanımı kolay bi uygulama. Harika!!",
    username: "salihaksit",
    date: "Sep 6, 2025",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "It’s so much fun learning German now",
    text: "I have tried few application but I think this one is just perfect. The UI is clean, which helps me to focus on the language learning.",
    username: "Cool_Monk29",
    date: "Sep 4, 2025",
    rating: 5,
    country: "Japan",
  },
  {
    title: "Useful and easy-to-use German Flashcards app",
    text: "This app is a very useful for those who wants to improve their language skills in German or who wants to learn from zero.",
    username: "AVILDEV",
    date: "Sep 1, 2025",
    rating: 5,
    country: "Armenia",
  },
  {
    title: "Exactly what we needed",
    text: "This app is exactly what we needed to learn German language. Easy and simple to use! Thank you for building this app.",
    username: "YLAMET",
    date: "Aug 24, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Minimalistic app for true-learners",
    text: "So far best app for learning vocab and practicing sentence making. No ads. Super!",
    username: "CaptainSam222",
    date: "Aug 14, 2025",
    rating: 5,
    country: "Slovakia",
  },
  {
    title: "Simple and super useful",
    text: "I've really enjoyed using Linguico. It makes language learning feel easy and logical. It’s great for any level — beginner or advanced. I especially like the option to practice gender, which many apps skip. And having so much useful info in one place really helps me stay focused.",
    username: "Chernika-Malina",
    date: "Jul 22, 2025",
    rating: 5,
    country: "Ukraine",
  },
  {
    title: "Nice flashcards app",
    text: "This app is very intuitive and perfect for beginners learning German. It makes studying vocabulary simple and enjoyable. No fancy UI that make it even better to be focused on learning a new language",
    username: "Kostya-89",
    date: "Jul 7, 2025",
    rating: 5,
    country: "Argentina",
  },
  {
    title: "Great for learning German",
    text: "This app is a fantastic resource for anyone serious about learning German, especially those preparing for the Goethe exam. It aligns perfectly with the Goethe vocabulary lists, making it an ideal companion for exam preparation. Linguico has a textbook-like feel, perfect for those who appreciate in-depth content.",
    username: "SSG85",
    date: "Jul 4, 2025",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Recomiendo",
    text: "Me gusta la app. Estaría genial que pudieran eliminarse las palabras que ya se conocen para que no se pierda tiempo en ponerlas en la casilla verde de que se conocen. Igual que pudiera tener traducción al español. Gracias y adiós les bendiga",
    username: "Review7177",
    date: "Jun 21, 2025",
    rating: 4,
    country: "Mexico",
  },
  {
    title: "Great App for Learning German! ⭐⭐⭐⭐⭐",
    text: "This app is one of the best for learning German! It covers 15,000+ useful words with smart flashcards, clear grammar tables, and fun exercises. The “der, die, das” trainer is super helpful, and everything is designed to be practical and easy to use. Perfect for learning on the go—highly recommended!",
    username: "Shayanypn",
    date: "Jun 1, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Practice your German words",
    text: "I love it to practice german words by gender",
    username: "Ciaala",
    date: "May 18, 2025",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "Great app",
    text: "Very helpful! Great for beginners.",
    username: "Sarah@007",
    date: "May 5, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "I can’t believe this app is totally free",
    text: "I would be happy to pay a one time fee for it (no subscription please). Can’t wait for the developer to add more languages. Please consider adding Norwegian Bokmål. Thank you!",
    username: "Janey Gold",
    date: "Apr 4, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Enkelt och naturligt",
    text: "Väldigt smidigt att komma igång. Äntligen en app som gör det naturligt och enkelt att lära sig språk. 5/5 ⭐️",
    username: "Gerardlondon",
    date: "Apr 2, 2025",
    rating: 5,
    country: "Sweden",
  },
  {
    title: "Good way to learn German vocabulary",
    text: "I use this app a lot for learning German words with the Anki style flashcards. I love the details added to each flashcards, like the irregular verb conjugations. In addition, I like the grammar exercises and the exercises for learning der, die, das.",
    username: "Vivek beladiya",
    date: "Apr 2, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "Built well",
    text: "Fun and useful!",
    username: "Sell Shovels",
    date: "Mar 31, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Linguico: The Smart Way to Master German Vocabulary ⭐⭐⭐⭐⭐",
    text: "After trying countless language apps, Linguico stands out as the most effective tool for learning German vocabulary. Unlike generic flashcard apps, Linguico is specifically designed for German learners with thoughtfully curated content. The app's greatest strength is its high-quality built-in flashcards. Rather than wasting time with inconsistent public Anki decks, Linguico provides professionally created cards for 15,000 German words, organized by frequency. This approach ensures you learn the most useful vocabulary first - a huge time-saver! Each flashcard goes beyond basic translations by including:\n- Clear grammar information\n- Irregular forms (crucial for German!)\n- Practical example sentences\n- Native speaker audio\n\nThe official wordlists feature is excellent for structured learning, letting you choose between Goethe Institute A1, A2, or B1 levels. This alignment with recognized standards gives you confidence that you're learning exactly what you need for tests or real-world conversations.\n\nThe spaced repetition system works brilliantly, adjusting to your learning pace and ensuring words stick in your long-term memory. The interface is clean and intuitive, making daily practice enjoyable rather than a chore.\n\nIf you're serious about learning German vocabulary efficiently, Linguico is worth every penny. It's transformed my German learning journey from frustrating to rewarding!",
    username: "asabaterg",
    date: "Mar 20, 2025",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "Super",
    text: "Benutze die app jetzt seit mehreren monaten und bin begeistert wie gut und einfach das ganze ist.",
    username: "Cancan338",
    date: "Mar 20, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "game-changer for German Learning",
    text: "This app is a game-changer for learning German. I love the flashcards for learning German vocabulary, it is much better than any Anki deck. In addition, great exercises for practicing grammar and German articles.",
    username: "wwwwwwwkkkkkkkkxxxxxxxz",
    date: "Mar 14, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Oh, that’s fun!",
    text: "Fantastic tool! Perfect for beginners and advanced learners alike!",
    username: "Sasharon74",
    date: "Mar 13, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Awesome app for learning!",
    text: "The best app for learning German vocabulary and for learning the correct articles 'der, die, das'.",
    username: "Jacob_BHW",
    date: "Mar 10, 2025",
    rating: 5,
    country: "South Africa",
  },
  {
    title: "Great app for German!",
    text: "Taking a trip to Germany this year and have been wanting to get an app to get my German up to par to get by conversationally. This is great for newbies like me or more advanced German Speakers to get better with the language!",
    username: "sku424242",
    date: "Mar 10, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Fantastic App",
    text: "Learning German with flashcards and grammar lessons!! I like that lessons are just like in school courses! Also lots of grammar exercises.",
    username: "Filmkritiker2012",
    date: "Mar 5, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "A great app to learn German.",
    text: "This is a really really cool app to learn German for beginners!! I’m enjoying it so far.",
    username: "dayvoid97",
    date: "Mar 5, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Learning German got so easy with the app!",
    text: "Excellent app for learning German. Great flashcards for learning vocabulary that are better than Anki flashcard.",
    username: "chi-chi8595",
    date: "Mar 3, 2025",
    rating: 5,
    country: "Philippines",
  },
  {
    title: "A Must Have German Learning App!",
    text: "I have had this app for over a week now and I must say, the simplicity of the app doubles its efficiency to learn German language using flashcards. You can choose from different lessons, learn German vocabulary, improve your grammar and practice daily easy to difficult challenges to get proficient at German language learning. I recommend it.",
    username: "MasterSherlock93",
    date: "Feb 27, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Recommend!",
    text: "Great app and very valuable! Would recommend!",
    username: "Tenicho2",
    date: "Feb 27, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Really helpful!",
    text: "This app has been super helpful. It's really simple to use. Whenever I have free time I can do quick German lessons.",
    username: "ToseefDon",
    date: "Feb 25, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "Perfect flashcards app",
    text: "Very innovative and easy to use app. Started loving it from the day one.",
    username: "Santu Dey",
    date: "Feb 25, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "برنامج ممتاز",
    text: "سعدتني اتعرف على كلمات جديدة و احسن نطق بالألمانية",
    username: "Arshavin17",
    date: "Feb 22, 2025",
    rating: 5,
    country: "United Arab Emirates",
  },
  {
    title: "Great app to learn German",
    text: "This is my go to app to learn German. The UI is great app flashcards are very useful.",
    username: "ran10153",
    date: "Feb 19, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "Puiki ir naudinga programėlė!",
    text: "Naudojausi šia programėle norint pagerinti savo vokiečių kalbos žinias. Patiko rašybos pratimai bei pats kortelių konspektas, kuris geriau padėjo įsiavinti medžiagą, rekomenduoju!",
    username: "MartynasAsas",
    date: "Feb 18, 2025",
    rating: 5,
    country: "Lithuania",
  },
  {
    title: "Great for learning German!",
    text: "Linguico is great for practicing the language, and the app offers all the resources to help you study and understand cases in German. I love that I can customise my learning experience.",
    username: "🌞",
    date: "Feb 17, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Enjoyed it much",
    text: "Excellent app for learning German. I use this app in particular for learning vocabulary.",
    username: "kkanchev94",
    date: "Feb 16, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Sehr gute App",
    text: "Schön und gut!!",
    username: "medigruber",
    date: "Feb 12, 2025",
    rating: 5,
    country: "Austria",
  },
  {
    title: "Gut",
    text: "Отличные карточки, артикли, лучше остальных приложений. Из минусов - нет перевода с русского",
    username: "Admi78Rus",
    date: "Feb 12, 2025",
    rating: 5,
    country: "Russia",
  },
  {
    title: "Tyske flashcards",
    text: "Fantastisk god app for å lære tysk. Bruker denne appen regelmessig for å friske opp mitt tyske ordforråd og grammatikk etter å ha glemt det meste fra skolen. Anbefales!",
    username: "Helgemat",
    date: "Feb 11, 2025",
    rating: 5,
    country: "Norway",
  },
  {
    title: "Excelente app para aprender alemán",
    text: "La aplicación es muy sencilla y práctica y te presenta con tarjetas de gramática y vocabulario de alemán con distintos niveles, te permite personalizar la experiencia para aprender más rápido. Recomendable!",
    username: "Grantory",
    date: "Feb 11, 2025",
    rating: 5,
    country: "Spain",
  },
  {
    title: "Awesome app!",
    text: "Great app, really helping me learn German!",
    username: "D1n0_nugg3t",
    date: "Feb 11, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Корисний додаток",
    text: "Дуже зручний додаток для вивчення німецької мови. Також сподобалось зручне переключення з німецької на англійську мову. Дуже дякую розробникам 🙂",
    username: "Healer928802",
    date: "Feb 10, 2025",
    rating: 5,
    country: "Ukraine",
  },
  {
    title: "Impariamo il tedesco",
    text: "Era da un po’ che cercavo un app per imparare il tedesco e quest’app è perfetta perché ha moltissime lezioni di grammatica con spiegazioni chiare e dettagliate e per verificare l’apprendimento puoi svolgere gli esercizi. Ottima!",
    username: "Catta.",
    date: "Feb 9, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Fajne!",
    text: "Bardzo przydatna aplikacja do nauki niemieckiego. W przyjemny sposób pomogła mi odświeżyć już mocno zapomniane podstawy :)",
    username: "krzysiek.sadowski",
    date: "Feb 9, 2025",
    rating: 5,
    country: "Poland",
  },
  {
    title: "Very useful",
    text: "Very nice app to learn German. I really like the offline dictionary and it is easy to use. Thank you!",
    username: "K3v!",
    date: "Feb 8, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Quite Helpful",
    text: "This is a great little app for brushing up my German skills that I haven’t put to much use since secondary school!",
    username: "G.Harte",
    date: "Feb 8, 2025",
    rating: 5,
    country: "Ireland",
  },
  {
    title: "Very nice and well made app!",
    text: "No need to say much, it is very useful app, using it every day!",
    username: "sabiland",
    date: "Feb 8, 2025",
    rating: 5,
    country: "Slovenia",
  },
  {
    title: "Skuteczna nauka niemieckiego",
    text: "Fajna apka do nauki zaimków, słownictwa oraz czasów. Polecam szczególnie początkującym i średniozaawansowanym",
    username: "Bogu86",
    date: "Feb 8, 2025",
    rating: 5,
    country: "Poland",
  },
  {
    title: "Magnifico",
    text: "Fantastico modo per imparare il vocabolario tedesco. L’app offre molti contenuti utili ed esercizi per imparare il tedesco.",
    username: "Looker1989",
    date: "Feb 8, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Fantastic app for learning German!",
    text: "With 15,000+ flashcards, interactive exercises, and clear grammar summaries, it makes building vocabulary and mastering tricky articles like 'der, die, das' easy and effective. Perfect for beginners and advanced learners alike!",
    username: "Axel LP",
    date: "Feb 6, 2025",
    rating: 5,
    country: "France",
  },
  {
    title: "Helpful :)",
    text: "Helpful tool with clean and user-friendly interface",
    username: "Louis-f Celine",
    date: "Feb 5, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Tres bonne application",
    text: "Cette appli m a permis d apprendre assez rapidement l allemand et les bases ! Merci énormément aux développeurs pour ce petit bijou",
    username: "Zababplease",
    date: "Feb 3, 2025",
    rating: 5,
    country: "France",
  },
  {
    title: "Amazing concept",
    text: "Amazing app! Unique concept to learn German ❤️",
    username: "ninety99ne",
    date: "Feb 3, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "The only app that is teaching German Grammar",
    text: "The app is used in my German language class, and even the teacher thinks it's good. Great quality flashcards and drill exercises for der, die, das and prepositions. I also love that this app truly focuses on teaching German including grammar —unlike Duolingo.",
    username: "AndreiP3456",
    date: "Feb 3, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "⭐️5 estrelas!",
    text: "Estou aprendendo alemão há um ano (sozinho) e tenho tido muita dificuldade com a gramática... Algumas regras são muito complicadas, e é difícil encontrá-las em um só lugar. É por isso que fiquei muito feliz ao encontrar este aplicativo, onde tenho todas as regras bem explicadas em um só lugar + posso treinar tudo o que aprendi aqui com flashcards! É muito útil! E é gratuito!",
    username: "davi_costa_83",
    date: "Feb 2, 2025",
    rating: 5,
    country: "Brazil",
  },
  {
    title: "Nice app to practice German",
    text: "Pretty useful for a non native speakers to improve German skills",
    username: "Dhhdxv",
    date: "Feb 1, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Must have! 🙌",
    text: "If you're struggling to learn German like me… (oh my, those articles! 😫), you need this app! It organizes all the grammar rules in a clear, structured way, making them easy to find. Plus, you can practice with flashcards. And the best part? It's completely free! Can you believe it? Huge thanks to the developers!",
    username: "olivia_89",
    date: "Jan 31, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Amazing for everyday practice",
    text: "Essential and effective to learn from basics. Clear explanation of grammar. Perfect for who want to start or refresh knowledge!",
    username: "DaniiKey",
    date: "Jan 28, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Almanca kelime pratiği için birebir",
    text: "Almanca öğrenmeye karar verdim ve kelime öğrenmede sıkıntı çekiyordum. Flashcardlar sayesinde bu süreç kolaylaştı.",
    username: "Samed Dağlı",
    date: "Jan 28, 2025",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Helping me learn German",
    text: "I've been using this app, and I've picked up so many German words I never thought I would. It's a great and super easy app! great and very simple app.",
    username: "Sahad Alvi",
    date: "Jan 28, 2025",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Świetna aplikacja do nauki niemieckiego",
    text: "Planuje przeprowadzić się do Niemiec i muszę nauczyć się niemieckiego. Próbowałem wielu aplikacji i zdecydowanie z tej korzysta mi się najlepiej. Zauważyłem największy progres w mojej nauce niemieckiego właśnie korzystając z linguico. Polecam wszystkim chcącym nauczyć się niemieckiego.",
    username: "Łukasz Krawiec",
    date: "Jan 26, 2025",
    rating: 5,
    country: "Poland",
  },
  {
    title: "Tolle App",
    text: "Schön programmierte App zum lernen.",
    username: "Alex213443356677",
    date: "Jan 26, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Easy to use flash cards",
    text: "This app was super simple to start using and I have no education speaking German at all! I particularly like the text-to-speech feature, I think it really helps with memory and pronunciation.",
    username: "DoubleDotMaxx",
    date: "Jan 21, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Useful for learning german",
    text: "The app was useful to start speaking german.",
    username: "Alehano777",
    date: "Jan 21, 2025",
    rating: 5,
    country: "Portugal",
  },
  {
    title: "Great for beginners",
    text: "Just started using this app, great for me as a new learner! Easy to use, and works smoothly. The flashcards are helpful and there’s not too much going on to distract you. Recommend.",
    username: "Glen2510",
    date: "Jan 20, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Such amazing app",
    text: "I’m using this app everyday, I love the variety of exercises, from vocabulary to pronunciation practice, which makes learning fun and effective. The user interface is intuitive, and the progress tracking keeps me motivated. Highly recommended for beginners and advanced learners alike!",
    username: "ksalaheddine",
    date: "Jan 20, 2025",
    rating: 5,
    country: "Morocco",
  },
  {
    title: "Great on the go!",
    text: "It’s simple and straightforward, and I’ve been using it in the past few days to quickly refresh my mind when commuting. I see myself using it for a long while, thanks for making it!",
    username: "mcomisso",
    date: "Jan 19, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Easy way to learn German",
    text: "A great way to learn or improve your German language in an easy, simple way for English speakers like me.",
    username: "MohaHadji",
    date: "Jan 19, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Good for german",
    text: "I started using this app to make my german better. The flashcards and pronunciations are useful.",
    username: "Darinda777",
    date: "Jan 17, 2025",
    rating: 5,
    country: "India",
  },
  {
    title: "It helped me a lot",
    text: "This app is very effective for learning German. I particularly like the feature that allows you to practice your incorrect answers, which helps reinforce learning.",
    username: "Thomssie1",
    date: "Jan 17, 2025",
    rating: 5,
    country: "Slovakia",
  },
  {
    title: "Great app for beginners!",
    text: "This app has been super helpful as a beginner trying to learn German. It's been nice using the voiceover features, and the sleek design makes it easy to track my progress and jump around to different words. Really great design and nice features to help me begin learning the language!",
    username: "Ycishskskdhdisn",
    date: "Jan 11, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Awesome for learning German",
    text: "I love the different approach for learning German compared to apps like Duolingo. A great non-gamified approach to learning German with bite-sized lessons.",
    username: "drksks12234",
    date: "Jan 10, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Thank you",
    text: "Easy",
    username: "MeginGiord92",
    date: "Jan 2, 2025",
    rating: 5,
    country: "Germany",
  },
  {
    title: "The only app that teaches German grammar",
    text: "This app was mentioned on Reddit. It’s my favourite app for learning German, as it addresses shortcomings in other apps. It’s the only app that truly teaches grammar and includes nice extras for learning German vocabulary, with example sentences and grammar details like conjugations and irregular endings.",
    username: "Carter-1995",
    date: "Jan 1, 2025",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Easy and Efficient Learning",
    text: "I have been planning a trip to Germany with my friends to watch a couple soccer games. This app really helped me lock in a focus on learning what I needed to get by, without any annoying ads or distractions. Would definitely recommend!",
    username: "Vleo27",
    date: "Jan 1, 2025",
    rating: 5,
    country: "United States",
  },
  {
    title: "Effectief voor Duits leren",
    text: "Ik gebruik deze app al een om Duitse woordenschat te leren. Daarnaast zijn de grammatica lessen echt heel goed!",
    username: "Mevrouwwwww",
    date: "Dec 31, 2024",
    rating: 5,
    country: "Netherlands",
  },
  {
    title: "Super app",
    text: "Hat mir sehr geholfen",
    username: "EliasIlk",
    date: "Dec 28, 2024",
    rating: 5,
    country: "Austria",
  },
  {
    title: "È un ottima applicazione per imparare il Tedesco",
    text: "È molto utile per imparare parole nuove e per ripassare. Lo consiglio vivamente a tutti di provare!",
    username: "Fabio.Turchi",
    date: "Dec 16, 2024",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Great app to quickly learn a language",
    text: "I always wanted a simple flash card like app. This is a pretty good app for brushing up on German.",
    username: "ChaiNBoba",
    date: "Dec 15, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Almanca Öğrenmek İçin Harika",
    text: "Uygulama Almanca dilini öğrenmek için iyi bir yaklaşım geliştirmiş. Gereksiz ayrıntılardan uzak sadece dil öğrenme hedefli.",
    username: "engumt",
    date: "Dec 13, 2024",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "A good app for beginners",
    text: "This app perfectly matches my learning habits. The content is concise and clear. As a beginner in German, I must give it a positive review~",
    username: "—11(;",
    date: "Dec 11, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "An easy start to the German language",
    text: "Provides a neat and contained way to pick up and practice German. There are multiple way to learn from the app, and easy for beginners to get into.",
    username: "Jordan2048",
    date: "Dec 10, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Superbe concept",
    text: "L’application est très bien réalisée et facile à prendre en main, les lessons hyper complètes, très bien pensées avec un apprentissage graduel. Moi qui voulait avoir quelques notions avant un voyage dans le pays, l’app a été au rdv !",
    username: "lau_fr",
    date: "Dec 4, 2024",
    rating: 5,
    country: "France",
  },
  {
    title: "Perfect for Learning German!",
    text: "This app is fantastic for anyone learning German! The flashcards are well-organized, covering essential vocabulary and grammar. I love how interactive and intuitive the interface is—it makes learning fun and engaging. Highly recommend this app for beginners and advanced learners alike! 💪🇩🇪",
    username: "Rkramv8",
    date: "Dec 4, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "Great app",
    text: "I improved my German by a lot using this app. Recommend it to beginners and mid level apprentice speakers. Great!",
    username: "Danes888",
    date: "Dec 2, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Easy and effective",
    text: "Nice interface and intuitive learning - would definitely recommend for first-time German students",
    username: "HankP94",
    date: "Nov 29, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Great way to learn German vocabulary",
    text: "The German flashcards are of really good quality and very effective for improving my German proficiency.",
    username: "Samanta0071",
    date: "Nov 25, 2024",
    rating: 5,
    country: "Ukraine",
  },
  {
    title: "Simple, clear and very helpful",
    text: "German is one of the hardest languages to learn. I tried to learn it myself in the past but didnt really succeed. But this app has made it a lot easier with how clearly presented everything is as well as explanations, tests and application scenarios. Highly recommend for those having difficulty learning German.",
    username: "paddyfields888",
    date: "Nov 25, 2024",
    rating: 5,
    country: "Singapore",
  },
  {
    title: "Helpful app",
    text: "Easy to use on the go, learnt some great new German words and phrases",
    username: "h4z1994",
    date: "Nov 23, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Fantastic for German vocabulary",
    text: "Great app. It’s free and it works great for learning German words and grammar.",
    username: "FrogLoverFrog",
    date: "Nov 22, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Bra läromedel",
    text: "Bra app om man vill lära sig tyska. Enkelt att bara öppna appen och öva en stund. Också gott om förklaringar till grammatik osv.",
    username: "jekib",
    date: "Nov 21, 2024",
    rating: 5,
    country: "Sweden",
  },
  {
    title: "Effortlessly Learn German",
    text: "Great app for mastering German! The flashcards and grammar exercises are top-notch. Highly recommend for anyone serious about learning German.",
    username: "Shivam Pandey 659",
    date: "Nov 20, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "Müthiş 👌🏻👌🏻👌🏻👌🏻👌🏻",
    text: "Kullanımı çok kolay, arayüzü müthiş. Almanca öğrenem herkese tavsiye ederim 💞",
    username: "TunaDev",
    date: "Nov 18, 2024",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Beginner-Friendly",
    text: "A simple and effective German learning app with an intuitive interface. It makes daily learning very accessible, and I can feel myself improving bit by bit.",
    username: "SuperBigCat1",
    date: "Nov 16, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for German",
    text: "I was struggling with German for a while. This app is great to remember words and improve!",
    username: "downloadLinkzy",
    date: "Nov 15, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Großartig",
    text: "It’s amazing. The app is very simple and pleasant to use. There are no ads and it’s free and yet it offers so much. I’m truly thankful to the developer, amazing work!",
    username: "Antares801",
    date: "Nov 13, 2024",
    rating: 5,
    country: "Poland",
  },
  {
    title: "One of the best",
    text: "15000 word deck WITH gender practice WITH grammar lessons FOR FREE?! Legit one of the best German learning tools out there.",
    username: "jdhdjdhdhgd",
    date: "Nov 8, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Make learning languages easier !!!",
    text: "This app is really simple to use which makes the learning process a lot easier. Can’t go wrong with this.",
    username: "Allenwei556",
    date: "Nov 7, 2024",
    rating: 5,
    country: "Taiwan",
  },
  {
    title: "Love it!!",
    text: "Cool app with nice German flashcards for vocabulary. I like the grammar lessons too. The app is currently only for learning German. I hope more languages will be added.",
    username: "Ellie1843",
    date: "Nov 6, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Great to learn German",
    text: "Definitely see some improvements.",
    username: "No-Biscotti",
    date: "Nov 6, 2024",
    rating: 5,
    country: "New Zealand",
  },
  {
    title: "A boost!",
    text: "Ideal for boosting your German word count and grammar. Recommended!",
    username: "Zenopolis",
    date: "Nov 6, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Good for learning German",
    text: "Useful flashcards for learning vocabulary. The app is great for truly learning German, including grammar.",
    username: "Tusher266",
    date: "Nov 6, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Great app to learn German.",
    text: "I’m using the app for a few days now and it’s just amazing. Every day I’m having progress and learning new words in German.",
    username: "niczwier",
    date: "Nov 5, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Nützlich zum Üben von der die das",
    text: "Diese App ist krass um die deutschen Artikel zu üben. Sie macht das Lernen von “der die das” viel einfacher.",
    username: "DenSim26",
    date: "Nov 5, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Recomand!!",
    text: "O aplicatie foarte folositoare pentru cei care vor sa invete limba germana. Am reusit sa invat intr-un timp foarte scurt si intr-un mod interactiv.",
    username: "AndreiSiclovan",
    date: "Nov 5, 2024",
    rating: 5,
    country: "Romania",
  },
  {
    title: "Great German learning app",
    text: "Easy to use and actually breaks down the most confusing grammar and helps me remember more vocabulary. Would recommend to anyone who is struggling with learning German.",
    username: "podrickoayb3",
    date: "Nov 4, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Really helpful!",
    text: "I got this app after seeing it in a German language forum. I’m not new to German, but it’s been a long time and Duolingo wasn’t teaching me the grammar. This has been really helpful and helps the grammar click for me. Highly recommend!",
    username: "AnalogPickleCat",
    date: "Nov 3, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Very thoughtful app",
    text: "Used this app for about a month, very easy to use, just follow the lessons daily can really help to remember German!",
    username: "mablic",
    date: "Nov 3, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Super easy to use",
    text: "Been looking for an app like this for a while and i’m glad i found it! Would recommend it to any friends who are also learning german :)",
    username: "jdjdjsa",
    date: "Nov 3, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Such a simple and fun app",
    text: "The app really offers a simple way to practice common challenges one faces in German. Really plan to use it regularly to see how it evolves and how I evolve too",
    username: "wilson972",
    date: "Nov 2, 2024",
    rating: 4,
    country: "France",
  },
  {
    title: "Useful app, easy to follow, not too overwhelming.",
    text: "I like that it's broken into small words and small matching practices, doesn’t overwhelm me to learn. I do it when I feel like it and I like the sounds as well",
    username: "imsnk8",
    date: "Nov 2, 2024",
    rating: 5,
    country: "Australia",
  },
  {
    title: "Fijne app voor Duits leren",
    text: "Ik gebruik deze app om Duits te leren. Goede oefeningen om Duitse woordenschat te leren en grammatica te oefenen.",
    username: "Legisuit",
    date: "Oct 30, 2024",
    rating: 5,
    country: "Netherlands",
  },
  {
    title: "Great for learning German",
    text: "I wish I knew this app before visiting Germany and Switzerland. Very simple, but very powerful app. I especially love the flashcards mini-game to learn new vocabulary.",
    username: "David Pelletier",
    date: "Oct 27, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Great German Flashcards",
    text: "I love the flashcards for learning German vocabulary. The word deck is of great quality. If you like Anki flashcards, you will love this app.",
    username: "ddiehard21",
    date: "Oct 27, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "Super helpful",
    text: "Very handy for my beginner level",
    username: "Funky_Smuggler",
    date: "Oct 24, 2024",
    rating: 5,
    country: "Netherlands",
  },
  {
    title: "Very effective for learning German",
    text: "Excellent German flashcards and grammar summaries for improving German proficiency. I like the grammar lessons, please add more!!",
    username: "M_J_H_",
    date: "Oct 24, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Simple, Organised, and Rich",
    text: "German Flashcards helped me a lot and the simple organised structure of the app helps keeping in track.",
    username: "Mohd.Rony",
    date: "Oct 23, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Skvělá aplikace na němčinu",
    text: "Skvělá appka na učení němčiny, s Anki kartičkami a spoustou gramatických cvičení.",
    username: "jirihrabak",
    date: "Oct 23, 2024",
    rating: 5,
    country: "Czech Republic",
  },
  {
    title: "Sehr tolle app",
    text: "Die App hilft meiner Freundin sehr Deutsch zu lernen und verstehen. Sie ist sehr zufrieden und sie macht bessere Fortschritte als bei Duolingo. Aufjedenfall zu empfehlen!",
    username: "Ninothefino",
    date: "Oct 17, 2024",
    rating: 5,
    country: "Austria",
  },
  {
    title: "Easy to learn German",
    text: "Had a great time using it. I LOVE that there’s a dictionary.",
    username: "Marlowe Clarke",
    date: "Oct 17, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great companion app for language learners!",
    text: "Perfect for focusing on grammar, especially for German. Pairs well with apps like Duolingo to enhance your learning experience.",
    username: "MrPansson",
    date: "Oct 17, 2024",
    rating: 5,
    country: "Sweden",
  },
  {
    title: "Amazing app considering it’s free!!!",
    text: "I really loved the gender quizzes for nouns but the grammar lessons themselves are great too!",
    username: "Rick Slickerz",
    date: "Oct 14, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Kelimeleri öğrenmek için çok kullanışlı",
    text: "Cümle yapılarını pratik etmede de çok faydalı bir uygulama. Tavsiye ederim",
    username: "Thonderstrike",
    date: "Oct 13, 2024",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Geniale App",
    text: "Hat mir sehr geholfen, wunderschön designed und sehr einfach zu bedienen!",
    username: "BorisCohen",
    date: "Oct 12, 2024",
    rating: 5,
    country: "Austria",
  },
  {
    title: "It has been working well for me so far!",
    text: "I have multiple different apps that help me learn German but honestly this has everything all in one. I’ve been focusing a lot of grammar and I can genuinely say it’s helping me. As a native english speaker, I have a lot of trouble grasping gendered nouns and this app has a dedicated gendered section and gives you helpful tips for you to better remember them.",
    username: "LaneyyyB",
    date: "Oct 11, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Unbelievably bad!!",
    text: "The pronunciation on this app is an absolute joke! It’s a machine reading German words and pronouncing them in English. Pathetic!",
    username: "Srt5547",
    date: "Oct 11, 2024",
    rating: 1,
    country: "United Kingdom",
  },
  {
    title: "Great for learning German",
    text: "Perfect app for learning German words. Very good for learning German grammar with theory explanations and exercises.",
    username: "Puska19",
    date: "Oct 8, 2024",
    rating: 5,
    country: "Hungary",
  },
  {
    title: "Effective app for truly learning German",
    text: "I am taking a German course, and this is the only app that has been recommended by the teacher. This app effectively replaces both Duolingo and Anki. It is the only app that focuses on both German grammar and vocabulary. It goes into great depth on grammar topics, just like a school book.",
    username: "mbt101",
    date: "Oct 8, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Great for learning German",
    text: "Perfect app for learning German words. Very good for learning German grammar with theory explanations and exercises.",
    username: "Puska19",
    date: "Oct 8, 2024",
    rating: 5,
    country: "Hungary",
  },
  {
    title: "Really nice app",
    text: "Very useful when you are struggling with the German language. I helps always having a fresh content.",
    username: "AhmedMoustafa92",
    date: "Oct 7, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Favorite 👏🏼👏🏼👏🏼",
    text: "Very practical to practise German. Effective on the vocabulary and articles",
    username: "theunlimited'",
    date: "Oct 7, 2024",
    rating: 5,
    country: "Netherlands",
  },
  {
    title: "Good app that focusses on German grammar",
    text: "I am taking a German course. My German teacher recommended that we use this app because it is the only German learning app that focuses on grammar topics. I agree.",
    username: "Chris94ha",
    date: "Oct 6, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Great App",
    text: "Superb for learning german, easy and for various difficulties!",
    username: "Hilda Cirule",
    date: "Oct 6, 2024",
    rating: 5,
    country: "Latvia",
  },
  {
    title: "Almanca öğrenmek için süper",
    text: "Özellikle quiz yapabildiğim için Almanca öğrenirken çok fayda sağladı.",
    username: "Melioda Nor",
    date: "Oct 6, 2024",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Alternatiflerinden çok iyi",
    text: "Uzun zamandır Almanca öğrenmek için çalışmalar yapıyorum şuana kadar kullandığım uygulamalardan çok daha iyi, alternatifleri sadece her gün girmemizi sağlayarak kendi ceplerini dolduruyorlar. Almanca kelime ve gramer öğrenmek için harika bir uygulama.",
    username: "Can Elliot",
    date: "Oct 4, 2024",
    rating: 5,
    country: "Türkiye",
  },
  {
    title: "Simple way to learn",
    text: "Had fun learning German.",
    username: "Evivz",
    date: "Oct 2, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "독일어 학습 좋네요!!",
    text: "독일어 단어 학습과 재미있는 문법 연습을 위한 아주 좋은 앱입니다.",
    username: "SNFZO",
    date: "Sep 29, 2024",
    rating: 5,
    country: "Korea, Republic of",
  },
  {
    title: "Top",
    text: "Application très efficace pour apprendre les mots allemands avec les flashcards Anki. L'application propose de nombreux exercices sur de nombreux sujets de grammaire allemande.",
    username: "Swordse",
    date: "Sep 28, 2024",
    rating: 5,
    country: "France",
  },
  {
    title: "Exactly what I was looking for",
    text: "Good Anki flashcards for learning 15000 German words. The only app for learning German grammar just like in a school book.",
    username: "ItsBeacon",
    date: "Sep 28, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Fantastic app for German words and grammar",
    text: "I have been using Duolingo, but at some stage, I couldn't further improve my German with it. Linguico is the only app that focuses on German grammar. The Anki flashcards for learning vocabulary are also the best I have seen.",
    username: "mario495",
    date: "Sep 28, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Practicing German just like in school",
    text: "This app works great for learning German vocabulary with Anki style flashcards and for practicing German grammar just like in a school.",
    username: "Naomindlander",
    date: "Sep 28, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great apps for learning German language",
    text: "This app helps me a lot to learn about German language, thank you",
    username: "apipgaming21",
    date: "Sep 27, 2024",
    rating: 5,
    country: "Indonesia",
  },
  {
    title: "great app",
    text: "im an aspiring german learner and i found this app extremely helpful!",
    username: "byyungg",
    date: "Sep 25, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Good app",
    text: "Very good app for learning german",
    username: "Bob4254mac",
    date: "Sep 24, 2024",
    rating: 5,
    country: "Sweden",
  },
  {
    title: "Odlicna",
    text: "Sviđa mi se korišćenje aplikacije za unapređenje mog znanja nemačkih reči i gramatike. Aplikacija detaljno obrađuje gramatičke teme kao što su predlozi i nemački članci 'der, die, das'.",
    username: "AkrabDng",
    date: "Sep 23, 2024",
    rating: 5,
    country: "Bosnia and Herzegovina",
  },
  {
    title: "Eficient pentru învățarea vocabularului german",
    text: "Învăț vocabularul german mult mai eficient decât înainte. Îmi plac tabelele concise de rezumat al gramaticii.",
    username: "Frizles66",
    date: "Sep 23, 2024",
    rating: 5,
    country: "Romania",
  },
  {
    title: "Replace your German course with this app",
    text: "I love Duolingo, don’t get me wrong. But this app does what other language apps don’t. It provides German learning in an easy, intuitive manner that can replace a school course (which Duolingo can’t). Personally, when I learn a language, I need to practice verb conjugations. This app provides a gamified solution to conjugation practice and I love it! Thank you guys!",
    username: "Misteryio101",
    date: "Sep 22, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "The best german learning app out there",
    text: "I really love the simplicity and the vast array of language learning tools available.",
    username: "Arafaysaleem",
    date: "Sep 22, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Jako korisna aplikacija",
    text: "Veoma korisna aplikacija, posebno flash cards, mnogo su bolje nego Anki app. Zanimljiv koncept ucenja gdje imas dobar pregled cjeline koju zatim mozes vjezbati kroz razne vjezbice.",
    username: "_capoeira_",
    date: "Sep 21, 2024",
    rating: 5,
    country: "Bosnia and Herzegovina",
  },
  {
    title: "Neeeeat",
    text: "The flash card is exactly what I need for language learning!",
    username: "Jjack2685",
    date: "Sep 21, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Spatial Repetition Learning!",
    text: "Great app to help brush up on my German using Anki Style cards. The tts is helpful getting the pronunciation right also!",
    username: "Lgcfrvkitdvk",
    date: "Sep 21, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for learning German.",
    text: "Learning through virtual flashcards is an excellent way to reinforce knowledge!",
    username: "Dr.bloom",
    date: "Sep 20, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "#1 app to learn German",
    text: "Linguico is a fun and effective app for learning German through engaging flashcards and interactive games. It makes language learning accessible, combining useful vocabulary with an enjoyable experience. Perfect for learners of all levels! I also love that it’s free and you don’t need to make an account!",
    username: "Jefficthepic",
    date: "Sep 20, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Odlična app",
    text: "Super aplikacija za učenje njemačkog uz vježbe gramatike",
    username: "domagor",
    date: "Sep 20, 2024",
    rating: 5,
    country: "Croatia",
  },
  {
    title: "Ausgezeichnet",
    text: "Sehr hilfreich, um den deutschen Wortschatz zu erweitern und die Kenntnisse von der, die, das zu verbessern. Wirklich die beste App für 'der die das', da die App Hinweise zeigt, welcher Artikel korrekt ist.",
    username: "Sarfraz_",
    date: "Sep 18, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Great app!: very helpful and straight forward",
    text: "This is actually a really helpful application for a few reasons! And specifically for me as someone who doesn’t speak German, but has an interest in learning it, that it seems like there are patterns and similarities between English and German that should be easy to get, but it’s still very hard for me. I like how this really does lay it out there plain and simple, and in a way that actually does stick. This is the way I learn best. Thanks!!",
    username: "riv3r1andstr3ams",
    date: "Sep 18, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for German lessons",
    text: "As someone who's always wanted to learn German but struggled with traditional methods, this app has been a revelation. The 15,000-word vocabulary feature is impressive, covering everything from beginner to advanced levels. What I really appreciate is the focus on practical, commonly used words - it feels like I'm learning German I can actually use.",
    username: "M84rtin",
    date: "Sep 17, 2024",
    rating: 5,
    country: "Norway",
  },
  {
    title: "Good",
    text: "It makes my learning German easier.",
    username: "quanlvvn",
    date: "Sep 17, 2024",
    rating: 5,
    country: "Vietnam",
  },
  {
    title: "Very good!",
    text: "The app works well for what it's intended to do, easy to learn new words, rules and phrases!",
    username: "jxnata",
    date: "Sep 16, 2024",
    rating: 5,
    country: "Brazil",
  },
  {
    title: "Best app",
    text: "A game changer for language learners application.",
    username: "imTonyStark",
    date: "Sep 16, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "Helpful app for learning a new language",
    text: "Linguistic offers some really helpful tools to learn a new language. It also has a very clean and reactive experience :)",
    username: "JaceS23",
    date: "Sep 14, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Practical way to support my German learning",
    text: "I’ve been learning German mostly with Assimil and it can be confusing at times. This app allows me to quickly refer to specific cases and grammar, and test my memory of them. Very helpful as a reference and review tool!",
    username: "Léomorpho",
    date: "Sep 14, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Great app",
    text: "It’s the best app for learning German I have found, other apps don’t focus on the specifics of the language as much. It has great tutorials and practice lessons that you won’t find in other apps.",
    username: "Daniella GF",
    date: "Sep 14, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Nice app for German learner",
    text: "The app offers nice and minimal features for learning German words and improving German grammar through various exercises which are very convenient for the beginner like me.",
    username: "Ben.Kit",
    date: "Sep 13, 2024",
    rating: 5,
    country: "Thailand",
  },
  {
    title: "Love this app!",
    text: "I use the app to learn German. I learn German words very fast through the flash cards that include grammar details, highly recommend this app!",
    username: "de_Pigeon",
    date: "Sep 13, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Amazing, Quick, and Easy!!!",
    text: "Excellent app for learning German. High quality flash cards for learning vocabulary and plenty of grammar exercises. Grammar summaries are perfect for reading during commutes.",
    username: "michxnam",
    date: "Sep 12, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Effective and User-Friendly German Learning App",
    text: "This app is great for learning German. The lessons are clear, and the practice exercises are really helpful. I’m noticing progress every day. It’s been a great tool for building my vocabulary and understanding grammar.",
    username: "luximetr.sync",
    date: "Sep 12, 2024",
    rating: 5,
    country: "Singapore",
  },
  {
    title: "It just works",
    text: "Very simple app, easy to use. I wanted to refresh my German I learned a long time ago and I found it helpful.",
    username: "Passatgt",
    date: "Sep 12, 2024",
    rating: 5,
    country: "Hungary",
  },
  {
    title: "simple and easy to use",
    text: "Loved the app it’s really great",
    username: "wayfarer2503",
    date: "Sep 11, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "App para aprender alemán perfecta",
    text: "Fabulosa App para aprender alemán!! Es una herramienta excelente para quienes buscan aprender y ampliar vocabulario en alemán. Las listas de palabras están bien organizadas por temas, lo que hace que el aprendizaje sea sencillo y efectivo. Es una aplicación simple y práctica, ideal para quienes buscan mejorar su alemán de manera rápida y enfocada. Muy recomendable!!",
    username: "AitorGR8",
    date: "Sep 8, 2024",
    rating: 5,
    country: "Spain",
  },
  {
    title: "Bardzo dobra apka do nauki języka niemieckiego",
    text: "Linguistic pomogła mi nauce języka niemieckiego",
    username: "localherodiscord",
    date: "Sep 8, 2024",
    rating: 5,
    country: "Poland",
  },
  {
    title: "This has been helpful",
    text: "I have really enjoyed using the interface of this app, it has been very easy to use and fun so far",
    username: "Rj212Rj",
    date: "Sep 8, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Nice app to learn german!",
    text: "I was testing the app and it’s really great! Good lessons, nice design, great learning experience!",
    username: "Paulkz",
    date: "Sep 6, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Great App to hone your German skills",
    text: "This App does not only focus on the vocabulary of the language, it also has focus on the articles, prepositions and cases. Can recommend.",
    username: "BigBart81",
    date: "Sep 6, 2024",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "L’appli parfaite pour apprendre l’allemand!",
    text: "Mon allemand était un peu rouillé et j’ai décidé de m’y remettre sérieusement, grâce à cette appli je suis en très bon chemin pour maitriser cette langue ô combien compliquée. Il y a tous les outils, les cartes de révisions et les tests sont superbes et en plus j’adore l’esthétique!",
    username: "Mr. Laed?",
    date: "Sep 6, 2024",
    rating: 5,
    country: "France",
  },
  {
    title: "Great way to learn German",
    text: "I have recently started learning German and I have found this way to be very easy to get started and it did improve my German words vocabulary by a lot.",
    username: "Viktorrtt",
    date: "Sep 5, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for learning German language",
    text: "Waiting for new language options :)",
    username: "Bohdan Kolesnyk",
    date: "Sep 5, 2024",
    rating: 5,
    country: "Ukraine",
  },
  {
    title: "Awesome",
    text: "A good workout and an amazing dictionary.",
    username: "manta1900",
    date: "Sep 5, 2024",
    rating: 5,
    country: "Greece",
  },
  {
    title: "And suddenly I'm learning German",
    text: "Stumbled upon this app with no real motivation to learn German, but a few days later I can speak full sentences!",
    username: "krs.tphr",
    date: "Sep 4, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Great Practice",
    text: "Great app to get some quick practice in - with helpful hints for each word too.",
    username: "awesome5185",
    date: "Sep 3, 2024",
    rating: 5,
    country: "Australia",
  },
  {
    title: "Cool and useful app",
    text: "German is really hard and I wanted to pick up a few words as I’m traveling there in a few months. The app does what it says it does and makes learning German easy and simple!",
    username: "Mggdhhfrg",
    date: "Sep 3, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Hilfreich",
    text: "Liefert vieles was das Sprachverständis fördert. Wichtige Grammatik immer auf Abruf!",
    username: "cmmntby",
    date: "Sep 2, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Effective and User-Friendly German Learning App",
    text: "This app is great for learning German. The lessons are clear, and the practice exercises are really helpful. I’m noticing progress every day. It’s been a great tool for building my vocabulary and understanding grammar.",
    username: "luximetr.sync",
    date: "Sep 12, 2024",
    rating: 5,
    country: "Singapore",
  },
  {
    title: "It just works",
    text: "Very simple app, easy to use. I wanted to refresh my German I learned a long time ago and I found it helpful.",
    username: "Passatgt",
    date: "Sep 12, 2024",
    rating: 5,
    country: "Hungary",
  },
  {
    title: "simple and easy to use",
    text: "Loved the app it’s really great",
    username: "wayfarer2503",
    date: "Sep 11, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "App para aprender alemán perfecta",
    text: "Fabulosa App para aprender alemán!! Es una herramienta excelente para quienes buscan aprender y ampliar vocabulario en alemán. Las listas de palabras están bien organizadas por temas, lo que hace que el aprendizaje sea sencillo y efectivo. Es una aplicación simple y práctica, ideal para quienes buscan mejorar su alemán de manera rápida y enfocada. Muy recomendable!!",
    username: "AitorGR8",
    date: "Sep 8, 2024",
    rating: 5,
    country: "Spain",
  },
  {
    title: "Bardzo dobra apka do nauki języka niemieckiego",
    text: "Linguistic pomogła mi nauce języka niemieckiego",
    username: "localherodiscord",
    date: "Sep 8, 2024",
    rating: 5,
    country: "Poland",
  },
  {
    title: "This has been helpful",
    text: "I have really enjoyed using the interface of this app, it has been very easy to use and fun so far",
    username: "Rj212Rj",
    date: "Sep 8, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Nice app to learn german!",
    text: "I was testing the app and it’s really great! Good lessons, nice design, great learning experience!",
    username: "Paulkz",
    date: "Sep 6, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Great App to hone your German skills",
    text: "This App does not only focus on the vocabulary of the language, it also has focus on the articles, prepositions and cases. Can recommend.",
    username: "BigBart81",
    date: "Sep 6, 2024",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "L’appli parfaite pour apprendre l’allemand!",
    text: "Mon allemand était un peu rouillé et j’ai décidé de m’y remettre sérieusement, grâce à cette appli je suis en très bon chemin pour maitriser cette langue ô combien compliquée. Il y a tous les outils, les cartes de révisions et les tests sont superbes et en plus j’adore l’esthétique!",
    username: "Mr. Laed?",
    date: "Sep 6, 2024",
    rating: 5,
    country: "France",
  },
  {
    title: "Great way to learn German",
    text: "I have recently started learning German and I have found this way to be very easy to get started and it did improve my German words vocabulary by a lot.",
    username: "Viktorrtt",
    date: "Sep 5, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for learning German language",
    text: "Waiting for new language options :)",
    username: "Bohdan Kolesnyk",
    date: "Sep 5, 2024",
    rating: 5,
    country: "Ukraine",
  },
  {
    title: "Awesome",
    text: "A good workout and an amazing dictionary.",
    username: "manta1900",
    date: "Sep 5, 2024",
    rating: 5,
    country: "Greece",
  },
  {
    title: "And suddenly I'm learning German",
    text: "Stumbled upon this app with no real motivation to learn German, but a few days later I can speak full sentences!",
    username: "krs.tphr",
    date: "Sep 4, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Great Practice",
    text: "Great app to get some quick practice in - with helpful hints for each word too.",
    username: "awesome5185",
    date: "Sep 3, 2024",
    rating: 5,
    country: "Australia",
  },
  {
    title: "Cool and useful app",
    text: "German is really hard and I wanted to pick up a few words as I’m traveling there in a few months. The app does what it says it does and makes learning German easy and simple!",
    username: "Mggdhhfrg",
    date: "Sep 3, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Hilfreich",
    text: "Liefert vieles was das Sprachverständis fördert. Wichtige Grammatik immer auf Abruf!",
    username: "cmmntby",
    date: "Sep 2, 2024",
    rating: 5,
    country: "Germany",
  },
  {
    title: "Best app for learning German vocabulary",
    text: "Linguistic has been great for learning German words with flashcards. I am preparing for the Goethe exams and have significantly improved my vocabulary and understanding of German articles: der die das.",
    username: "Levi198803",
    date: "Sep 1, 2024",
    rating: 5,
    country: "Hong Kong",
  },
  {
    title: "Recommend for beginners and intermediate learners",
    text: "This is a fantastic app for mastering German. The lessons are easy to follow. The pronunciation guides are a great help in getting the accent right. Highly recommend for beginners and intermediate learners!",
    username: "KeshS200",
    date: "Sep 1, 2024",
    rating: 5,
    country: "Sri Lanka",
  },
  {
    title: "Finally, a way to learn German without distractions",
    text: "I’ve been scouring ways to learn German vocabulary without all the nonsense of upselling paid services. I’ve been practicing grammar to improve my conversation with German relatives, who are constantly correcting the gender articles. It’s been a godsend finding an app that lets me practice just that! Drilling the der, die, das is something I can now do in my downtime between meetings or on-the-go! The voice readout is also quite clear-sounding.",
    username: "Diana 🍰",
    date: "Aug 30, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Great app for learning German vocabulary",
    text: "Great flashcards for learning German vocabulary. Effective exercises for practicing the German articles der, die, das.",
    username: "..,.,.,.,,,.m.",
    date: "Aug 28, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Fantastica per studiare",
    text: "Ottima app per imparare le parole tedesche con i flashcard. Mi piacciono i dettagli sulle coniugazioni dei verbi inclusi nei flashcard e la rilevanza delle parole. Ci sono degli ottimi esercizi di grammatica e allenamenti per gli articoli “der die das”. È stata molto utile per i miei studi di tedesco.",
    username: "Lello9800",
    date: "Aug 28, 2024",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Very useful!",
    text: "The best flashcards for learning German vocabulary and of much better quality than those in an Anki deck. Since the flashcards are ordered by frequency, you will only learn relevant German words. The der, die, das exercise with hints is really useful. The grammar summaries on prepositions are great and easy to read during my commute.",
    username: "Deeznutzinyamoufbiatch",
    date: "Aug 28, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Super helpful for learning German",
    text: "I love this app. I like the example sentences provided in the flashcards for learning German words. It also shows the verb conjugations and irregular endings. The best app for learning German vocabulary for both beginners and intermediate learners. Plenty of grammar exercises.",
    username: "gucci polish guy",
    date: "Aug 26, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Vocab learning",
    text: "The flashcards for learning vocabulary consist of relevant words and are of very good quality. I like the grammar summary tables, the der, die, das exercise, and the prepositions exercise. The der, die, das exercise helped me to correctly memorize the German articles. The content of this app is far more in-depth and superior to those of other language learning apps.",
    username: "junaid5595",
    date: "Aug 25, 2024",
    rating: 5,
    country: "Pakistan",
  },
  {
    title: "so hilfsbereit",
    text: "Diese App ist so gut und hilfsbereit! Es hilft dir durch alles! Es ist toll zu üben!",
    username: "bumcrackjuice",
    date: "Aug 22, 2024",
    rating: 5,
    country: "United Kingdom",
  },
  {
    title: "Recommended",
    text: "Good app for learning German language, includes both grammar description as well as verbal practice, etc.",
    username: "Norskj",
    date: "Aug 22, 2024",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "Nice app",
    text: "I've been using Linguistic: Learn German for a while now, and it's been a great experience. The summary tables on grammar are really good and well-structured. I love how the app breaks down the language into manageable chunks, making it less overwhelming. The exercises are practical and help reinforce what I've learned. I also appreciate the audio features, which make it easier to practice pronunciation. Whether you're just starting out or looking to improve your skills, this app is a solid choice. Highly recommend it to anyone wanting to learn German!",
    username: "Mixx234",
    date: "Aug 21, 2024",
    rating: 5,
    country: "India",
  },
  {
    title: "Convenient reference guide!",
    text: "A great guide to have for travel or for anyone who’s trying to learn the basics of German. I like how everything is broken down into easy to follow sections!",
    username: "AvidLearner38",
    date: "Aug 21, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "Amazing app!!",
    text: "I love the clean, minimalistic design! It's also super user-friendly and enjoyable to spend hours on, especially for vocabulary learning and reviewing grammar summaries. Overall, it's an excellent tool for German learners of all levels, from beginners to advanced.",
    username: "odifinlio",
    date: "Aug 17, 2024",
    rating: 5,
    country: "Canada",
  },
  {
    title: "Nice language app",
    text: "I’m currently learning German and this app helps me a lot to study this language and learn new vocabulary and improve my grammar.",
    username: "vathng",
    date: "Aug 16, 2024",
    rating: 5,
    country: "France",
  },
  {
    title: "Excellent app!",
    text: "Excellent app for learning and improving my German. Simple and intuitive interface that helps you to stay focused while studying. The app is much better for learning vocabulary with flash cards than the Anki App. I recommend it!",
    username: "Ewerton Wantroba",
    date: "Aug 14, 2024",
    rating: 5,
    country: "Brazil",
  },
  {
    title: "Love this app!",
    text: "Works great if you want to brush up before a trip!",
    username: "Shoppergamer",
    date: "Aug 13, 2024",
    rating: 5,
    country: "United States",
  },
  {
    title: "recommended",
    text: "My girlfriend uses it as she struggles with der die das.",
    username: "TBDaehler",
    date: "Aug 8, 2024",
    rating: 5,
    country: "Switzerland",
  },
  {
    title: "Comprehensive German Learning App",
    text: "I really liked the flashcards for refreshing my German vocabulary. The app also offers a wide range of grammar exercises, and I'm excited to see what new features the developer will add 😄.",
    username: "Dennis1802",
    date: "Aug 3, 2024",
    rating: 5,
    country: "Netherlands",
  },
  {
    title: "Utile e facile!",
    text: "Ho trovato questa app molto utile per ripassare prima dell’esame, la consiglio!",
    username: "Gabri mi",
    date: "Dec 13, 2025",
    rating: 5,
    country: "Italy",
  },
  {
    title: "Loved it!",
    text: "This app is really helpful for learning german. I have been using this for a while and completed most of the lessons. It’s fun and interactive and easy to understand german. Recommending it.",
    username: "sofia980",
    date: "Dec 13, 2025",
    rating: 5,
    country: "United States",
  },
];
